import React from 'react';
import { useTranslation } from 'react-i18next';

function Info() {
    const { t } = useTranslation();

    return (
        <div className="privacy-policy">
            <h3>{t('privacy.title')}</h3>
            <p>{t('privacy.intro')}</p>
            <p><strong>{t('privacy.noPersonalData')}</strong></p>

            <h5>{t('privacy.dataTitle')}</h5>
            <p>{t('privacy.analytics')}</p>
            <p>{t('privacy.localStorage')}</p>
            <p>{t('privacy.noTracking')}</p>

            <h5>{t('privacy.transferTitle')}</h5>
            <p>{t('privacy.transfer')}</p>

            <h5>{t('privacy.retentionTitle')}</h5>
            <p>{t('privacy.retention')}</p>

            <h5>{t('privacy.rightsTitle')}</h5>
            <p>{t('privacy.rights')}</p>

            <h5>{t('privacy.optOutTitle')}</h5>
            <p>
                {t('privacy.optOut')}
                <a target="_blank" rel="noopener noreferrer" href={t('privacy.vercelPrivacyUrl')}>
                    {t('privacy.vercelPrivacyUrl')}
                </a>.
            </p>
        </div>
    );
}

export default Info;
